import { useCallback } from 'react';
import type { FC } from 'react';
import { WarningDescription, HitboxFull } from '../../styled';
import Tooltip from '@components/Tooltip';
import FacebookIcon from '@assets/images/icons/vendor/facebook.svg';
import { SocialButtonContainer } from '../../styled';
import { useFacebook, ButtonState } from '../../hooks';
import { FacebookFullButton } from './styled';

interface Props {
  disabled?: boolean;
  onSuccess: (token: string) => void;
}
export const FacebookWebFull: FC<Props> = (props) => {
  const { warning, submitState, login } = useFacebook();
  const handleClick = useCallback(() => {
    login(props.onSuccess);
  }, [login, props.onSuccess]);
  return (
    <SocialButtonContainer>
      {warning !== '' && (
        <Tooltip
          light
          title={<WarningDescription>{warning}</WarningDescription>}
          openDelay={300}
          zIndex={99999}
        >
          <HitboxFull />
        </Tooltip>
      )}
      <FacebookFullButton
        display="block"
        styleType="loudLarge"
        disabled={props.disabled || submitState !== ButtonState.IDLE}
        onClick={handleClick}
        data-cy-id="button-facebook-login"
        isLoading={submitState === ButtonState.LOADING}
      >
        <FacebookIcon />
        Continue with Facebook
      </FacebookFullButton>
    </SocialButtonContainer>
  );
};
